const OVERRIDES = Symbol('overrides')

export type Mockable<T extends Record<string, any>> = T & {
  [OVERRIDES]: Partial<T>
}

export function mock<T extends Record<string, any>>(value: Mockable<T>, custom: Partial<T>) {
  Object.assign(value[OVERRIDES], custom)
  return value
}

export function reset<T extends Record<string, any>>(value: Mockable<T>) {
  value[OVERRIDES] = {}
}

export function mockable<T extends Record<string, any>>(value: T): Mockable<T> {
  const overrides: Partial<T> = {}
  
  const proxy = {} as Mockable<T>
  Object.defineProperty(proxy, OVERRIDES, {
    value: overrides,
    writable: true,
    enumerable: false,
    configurable: false,
  })
  
  for (const name of Object.keys(value)) {
    Object.defineProperty(proxy, name, {
      get: () => (name in proxy[OVERRIDES] ? proxy[OVERRIDES][name] : value[name]),
      enumerable: true,
      configurable: false,
    })
  }
  
  return proxy
}
